module.exports = __webpack_public_path__ + "static/assets/0118181eaebe999fcd6fe3f12c25c9ab.png";